import { render, staticRenderFns } from "./EditablePricingItem.vue?vue&type=template&id=5995163e&scoped=true"
import script from "./EditablePricingItem.vue?vue&type=script&lang=js"
export * from "./EditablePricingItem.vue?vue&type=script&lang=js"
import style0 from "./EditablePricingItem.vue?vue&type=style&index=0&id=5995163e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5995163e",
  null
  
)

export default component.exports